import { Text, TruncatedContent } from "@aurem/ui";
import { useI18n } from "providers/I18nProvider";
import { useGlobalSearchContext } from "../context";
import { SearchEmployee } from "../types";
import { SearchItemWrapper } from "./SearchItemWrapper";

type Props = {
  employee: SearchEmployee;
};

export const EmployeeSearchItem = ({ employee }: Props) => {
  const { t } = useI18n();
  const { handleItemClick } = useGlobalSearchContext();

  return (
    <SearchItemWrapper
      className="flex gap-2"
      onClick={() => handleItemClick(employee)}
    >
      <Text size="sm" className="shrink-0 whitespace-nowrap">
        {employee.firstName} {employee.lastName}
      </Text>
      <TruncatedContent className="text-sm text-neutral-500/50">
        {t("apps.admin.common.inCompany", employee.company.name)}
      </TruncatedContent>
    </SearchItemWrapper>
  );
};
